import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { decodeJwtPayload, NbAuthOAuth2JWTToken } from '@nebular/auth';
import { combineLatest, of, switchMap, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router: Router = inject(Router);

  return combineLatest([
    authService.nbAuth.isAuthenticated(),
    authService.nbAuth.getToken(),
  ]).pipe(
    switchMap(([isAuthenticated, token]) => {
      if (isAuthenticated) {
        return of(true);
      }

      if (!token || token.getPayload() === null) {
        return of(false);
      }

      console.log('Found token', token);

      const payload = decodeJwtPayload(
        (token as NbAuthOAuth2JWTToken).getRefreshToken()
      );
      const refreshExpired = payload.exp < Date.now() / 1000;
      console.log('Refresh expired: ', refreshExpired);

      if (refreshExpired) {
        return of(false);
      }

      return authService.nbAuth.isAuthenticatedOrRefresh();
    }),
    tap((isAuthenticated) => {
      console.log('Is authenticated: ', isAuthenticated);
      if (!isAuthenticated) {
        router.navigate(['/auth/login']);
      }
    })
  );
};
